export enum DischargePrescriptionType {
    Open = 1,
    DoctorRelease = 2,
    Halt = 7,    
}